require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-05-12-day-2-stuff-round-portland.json") })
        }
      }, "path---articles-2007-05-12-day-2-stuff-round-portland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-05-12-day-2-stuff-round-portland!./.cache/json/articles-2007-05-12-day-2-stuff-round-portland.json
// module id = 513
// module chunks = 231608221292675